// Compatibility messages are generated in a dozen places inside the store and
// arrive as shouted fragments with embedded newlines and stray punctuation:
//
//   "RAM SPEED MISMATCH \n, your computer will run at 2666 Mhz"
//
// They were written to be read inside a tooltip, but the completed-build screen
// prints them as prose. Normalising here fixes every generator at once instead
// of editing eight near-identical template literals.

// Words that must stay upper-case after the leading label is sentence-cased.
const ACRONYMS = /\b(ram|cpu|gpu|psu|tdp|atx|itx|sata|nvme|pcie|pci-e|ddr\d?|m\.2)\b/gi

// Unit casings the scrapers and message builders get wrong.
const UNIT_FIXES = [
    [/\bmhz\b/gi, 'MHz'],
    [/\bghz\b/gi, 'GHz'],
    [/\bgb\b/gi, 'GB'],
    [/\btb\b/gi, 'TB'],
]

export function formatCompatMessage(message){
    var text = String(message || '')
        .replace(/\s+/g, ' ')
        .replace(/\s+([,.;:])/g, '$1')
        .trim()

    if(!text){
        return ''
    }

    UNIT_FIXES.forEach(function(fix){
        text = text.replace(fix[0], fix[1])
    })

    // A leading run of ALL-CAPS words is a label ("RAM SPEED MISMATCH"), not
    // emphasis. Sentence-case it and set it off from the explanation with an em
    // dash. Greedy across whole words, so the label is the full run rather than
    // just its first word.
    var lead = text.match(/^([A-Z0-9][A-Z0-9/_-]*(?:\s+[A-Z0-9][A-Z0-9/_-]*)+)/)
    if(lead){
        var rest = text.slice(lead[0].length).replace(/^[\s,.:;—–-]+/, '')
        // Only a label when an explanation follows it. A message that is nothing
        // but capitals may be an acronym and is left exactly as written. The
        // multi-word requirement keeps a legitimate opener like "AMD socket ..."
        // from being mistaken for a shouted label.
        if(rest){
            var label = lead[1].trim().replace(/[_-]+/g, ' ')
            label = label.charAt(0) + label.slice(1).toLowerCase()
            label = label.replace(ACRONYMS, function(match){ return match.toUpperCase() })
            text = label + ' — ' + rest
        }
    }

    text = text.charAt(0).toUpperCase() + text.slice(1)
    // A trailing period only when it reads as a sentence, not on a bare label.
    if(text.indexOf(' ') !== -1 && !/[.!?]$/.test(text)){
        text += '.'
    }
    return text
}
